import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { HitmakerService } from 'src/app/core/services/hitmaker/hitmaker.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-hitmaker-new-main-page',
  templateUrl: './hitmaker-new-main-page.component.html',
  styleUrls: ['./hitmaker-new-main-page.component.css']
})
export class HitmakerNewMainPageComponent implements OnInit {

  constructor(private hitmakerService: HitmakerService, private router: Router, private userAuthentication: AuthenticationService,private spinner: NgxSpinnerService) { }

  bannerHeading: String = '';
  bannerDescription: String = '';
  bannerImageUrl: String = '';
  buttonName: String = '';
  buttonUrl: string = '';
  cards: any;
  pageData: any;
  userLoggedIn: Boolean = false;

  ngOnInit(): void {
    this.spinner.show();
    this.hitmakerService.getHitmakerMainpageContent().subscribe(data => {
      // console.log('Page data: ',data);
      this.pageData = data;
      this.setBannerImage(window.innerWidth);
      this.bannerHeading = this.pageData.title;
      this.bannerDescription = this.pageData.description;
      this.cards = this.pageData.infographicsContents.sort((a, b) => a.sequence - b.sequence);
      this.buttonName = this.pageData.buttonName;
      this.buttonUrl = this.pageData.buttonUrl;
      this.spinner.hide();
    });

    //Checking if user is logged in or not
    this.userAuthentication.checkUserAuthenticated().subscribe(data => {
      if(data.userId > 0) this.userLoggedIn = true;
      else this.userLoggedIn = false;
      console.log(this.userLoggedIn, 'user status');
    })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setBannerImage(event.target.innerWidth);
  }
  
  setBannerImage(width: number) {
    if (width > 1023) {
      this.bannerImageUrl = this.pageData.bannerImage;
    } else if(width > 600 && width < 1024 ) {
      this.bannerImageUrl = this.pageData.bannerImageForTablet;
    }
    else if(width < 601){
      this.bannerImageUrl = this.pageData.bannerImageForMobile;
    }
  }

  buttonAction(){
    if(this.userLoggedIn){
      let url = this.buttonUrl.replace(/[\s?]/g, '-').replace(/["]/g, '')
      window.location.href=url;
    }
    else {
      window.location.href="/login?referer=" + this.buttonUrl;
    }
  }

}
